// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"Feedback_submitButton__zJnph","success":"Feedback_success__CRkat","form":"Feedback_form__8ub8f"};